import { render, staticRenderFns } from "./DefinitionListItem.vue?vue&type=template&id=13ddd990&"
import script from "./DefinitionListItem.vue?vue&type=script&lang=js&"
export * from "./DefinitionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports